module.exports = __webpack_public_path__ + "img/tutorial02.7e94a265.svg";